import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY, LEGAL_LINKS, PORTALS } from "../../content/site";

const QUICK = [
  { label: "About", to: "/about" },
  { label: "Emergency Call-Out", to: "/emergency-call-out" },
  { label: "Triage Service", to: "/emergency-call-out/triage" },
  { label: "Areas We Cover", to: "/areas" },
  { label: "Facilities Management", to: "/facilities-management" },
  { label: "Out of Hours", to: "/facilities-management/out-of-hours" },
  { label: "NECOS.APP", to: "/facilities-management/necos-app" },
  { label: "Packages", to: "/about/packages" },
  { label: "Clients", to: "/clients" },
  { label: "Contractors", to: "/contractors" },
  { label: "Downloads", to: "/downloads" },
  { label: "Contact", to: "/contact" },
];

const Col = ({ title, children }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold">{title}</p>
    <div className="mt-5">{children}</div>
  </div>
);

const LinkList = ({ links, prefix }) => (
  <ul className="space-y-2.5">
    {links.map((l) => (
      <li key={l.to}>
        <Link to={l.to} className="link-underline text-[15px] text-mist hover:text-paper" data-testid={`${prefix}-${l.to.split("/").pop() || "home"}`}>
          {l.label}
        </Link>
      </li>
    ))}
  </ul>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t hairline bg-[#041626]">
    <div className="gold-glow pointer-events-none absolute -bottom-72 left-1/3 h-[560px] w-[760px] opacity-60" aria-hidden="true" />
    <div className="container-x relative py-16 sm:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr_1.2fr]">
        <div>
          <img src="/brand/logo-light.webp" alt="NECOS.FM" className="h-9 w-auto" width="130" height="36" loading="lazy" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-mist">
            Nationwide Emergency Call Out Services. 24/7 emergency call-out, telephone triage and facilities management for landlords and property managers across the UK.
          </p>
          <a href={COMPANY.hotlineTel} data-testid="footer-hotline-link" className="mt-8 inline-flex flex-col">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-alert-soft">24/7 Emergency hotline</span>
            <span className="mt-1 font-display text-3xl font-semibold text-gold">{COMPANY.hotline}</span>
          </a>
        </div>
        <Col title="Quick links"><LinkList links={QUICK} prefix="footer-link" /></Col>
        <Col title="Legal"><LinkList links={LEGAL_LINKS} prefix="footer-legal" /></Col>
        <Col title="Get in touch">
          <address className="not-italic space-y-4 text-[15px] text-mist">
            <p data-testid="footer-head-office"><span className="block font-mono text-[10.5px] uppercase tracking-[0.18em] text-gold/80">Head office</span>{COMPANY.headOffice.join(", ")}</p>
            <p data-testid="footer-address"><span className="block font-mono text-[10.5px] uppercase tracking-[0.18em] text-gold/80">Registered office</span>{COMPANY.address.join(", ")}</p>
            <p>
              <a href={`mailto:${COMPANY.email}`} className="link-underline text-paper" data-testid="footer-email">{COMPANY.email}</a>
            </p>
            <p>
              General enquiries:{" "}
              <a href={COMPANY.enquiriesTel} className="link-underline font-mono text-paper" data-testid="footer-enquiries">{COMPANY.enquiries}</a>
              <br />
              <span className="text-sm">{COMPANY.enquiriesHours}</span>
            </p>
          </address>
          <ul className="mt-6 flex flex-wrap gap-2">
            {PORTALS.map((p) => (
              <li key={p.id}>
                <a href={p.href} target="_blank" rel="noopener noreferrer" data-testid={`footer-portal-${p.id}`} className="inline-flex items-center gap-1 rounded-full border border-gold/20 px-3 py-1.5 text-xs text-paper hover:border-gold/60 hover:text-gold transition-colors">
                  {p.label} <ArrowUpRight className="h-3 w-3" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </Col>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t hairline pt-8 text-sm text-mist sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">© {COMPANY.name} · Company No. {COMPANY.number}</p>
        <p className="font-mono text-xs uppercase tracking-[0.18em]">necosfm.com</p>
      </div>
    </div>
  </footer>
);
